/** 获取外部联系人id */
export const getCurExternalContact = (): Promise<any> => new Promise((resolve) => {
  const wxSdk = parent?.window?.wx || window?.wx;
  if (!wxSdk) resolve({});
  wxSdk.invoke('getCurExternalContact', {}, async (wxres: any) => {
    if (wxres.err_msg === 'getCurExternalContact:ok') resolve(wxres);
    else resolve(wxres);
  });
});

/** 获取群聊id */
export const getCurExternalChat = (): Promise<any> => new Promise((resolve) => {
  const wxSdk = parent?.window?.wx || window?.wx;
  if (!wxSdk) resolve({});
  wxSdk.invoke('getCurExternalChat', {}, (wxres: any) => {
    if (wxres.err_msg === 'getCurExternalChat:ok') resolve(wxres);
    else resolve(wxres);
  });
});

/** 获取外部联系人id和群聊id */
export const getCurExternalContactAndChat = async () => {
  const [{ userId }, { chatId }] = await Promise.all([getCurExternalContact(), getCurExternalChat()]);

  if (!userId && !chatId) return;

  const type = userId ? 'contact' : 'chat';
  const id = userId || chatId;
  return { type, id };
};
